import { render, staticRenderFns } from "./OrganizationDashboardSection.vue?vue&type=template&id=0445494c&scoped=true"
import script from "./OrganizationDashboardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationDashboardSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationDashboardSection.vue?vue&type=style&index=0&id=0445494c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445494c",
  null
  
)

export default component.exports